module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$hydrowareSecurityJS.canDisplay_A('positions') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Manage Positions"
    }
  })], 1) : _c('div', {
    staticClass: "x_panel"
  }, [_vm._m(0), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel tile "
  }, [_c('div', {
    staticClass: "x_content"
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('positions')) ? _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 18,
      "md": 18,
      "sm": 18
    }
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                Position Name\n              ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Position Name",
      "maxlength": 30
    },
    on: {
      "change": _vm.checkSpace
    },
    model: {
      value: (_vm.position),
      callback: function($$v) {
        _vm.position = $$v
      },
      expression: "position"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 6,
      "md": 6,
      "sm": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "43px",
      "height": "36px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.position,
      "size": "medium"
    },
    on: {
      "click": _vm.addPosition
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n                  Add\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-table', {
    ref: "singleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.positions,
      "max-height": "450",
      "border": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Positions",
      "width": "320"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.editPosition && scope.row.PositionId == _vm.selectedpositionId) ? _c('el-input', {
          staticStyle: {
            "margin-bottom": "6px",
            "margin-top": "6px"
          },
          attrs: {
            "maxlength": 30,
            "placeholder": "Position"
          },
          on: {
            "change": _vm.checkSpace
          },
          model: {
            value: (_vm.currentPositionName),
            callback: function($$v) {
              _vm.currentPositionName = $$v
            },
            expression: "currentPositionName"
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.editPosition || scope.row.PositionId !== _vm.selectedpositionId) ? _c('span', {
          staticClass: "spacewrap"
        }, [_vm._v(_vm._s(scope.row.PositionName) + " \n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.editPosition && scope.row.PositionId == _vm.selectedpositionId),
            expression: "editPosition &&  scope.row.PositionId ==  selectedpositionId"
          }]
        }, [_c('el-button', {
          staticStyle: {
            "background-color": "green!important"
          },
          attrs: {
            "size": "small",
            "disabled": !_vm.currentPositionName,
            "title": "Save"
          },
          on: {
            "click": function($event) {
              return _vm.updateRole(scope.row.PositionId, scope.row.RoleId, _vm.currentPositionName)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-save",
          staticStyle: {
            "color": "black",
            "font-size": "13px"
          }
        })]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-bottom": "5px",
            "background-color": "purple!important"
          },
          attrs: {
            "icon": "el-icon-close",
            "size": "small",
            "title": "Cancel"
          },
          on: {
            "click": function($event) {
              _vm.editPosition = !_vm.editPosition, _vm.selectedpositionId = ''
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.editPosition || _vm.selectedpositionId ? scope.row.PositionId != _vm.selectedpositionId : _vm.editPosition),
            expression: "!editPosition || selectedpositionId ? scope.row.PositionId != selectedpositionId:editPosition"
          }]
        }, [_c('hydroware-edit-button', {
          staticClass: "hydroware-editNoEdit",
          attrs: {
            "disabled": _vm.shouldEditingBeDisabled(scope.row.PositionName)
          },
          on: {
            "click": function($event) {
              _vm.editPosition = true,
                _vm.selectedpositionId = scope.row.PositionId,
                _vm.currentPositionName = scope.row.PositionName,
                _vm.checkSpace
            }
          }
        }), _vm._v(" "), _c('span', [_c('hydroware-delete-button', {
          attrs: {
            "disabled": _vm.$hydrowareSecurityJS.canDelete_A('positions') == true && _vm.isADeliveredPosition(scope.row.PositionName) != null
          },
          on: {
            "click": function($event) {
              return _vm.DeletePosition(scope)
            }
          }
        })], 1)], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Assigned Role"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "hydroware-editNoEdit",
          staticStyle: {
            "width": "50%",
            "margin-top": "10px",
            "margin-bottom": "10px"
          },
          attrs: {
            "disabled": _vm.shouldEditingBeDisabled(scope.row.PositionName),
            "placeholder": "Select"
          },
          on: {
            "change": function($event) {
              return _vm.updateRole(scope.row.PositionId, scope.row.RoleId, scope.row.PositionName)
            }
          },
          model: {
            value: (scope.row.RoleId),
            callback: function($$v) {
              _vm.$set(scope.row, "RoleId", $$v)
            },
            expression: "scope.row.RoleId"
          }
        }, _vm._l((_vm.roles), function(role) {
          return _c('el-option', {
            key: role.Id,
            attrs: {
              "label": role.Name,
              "value": role.Id
            }
          })
        }), 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v("Manage Positions")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcc6c9d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Administration/Positions.vue
// module id = 856
// module chunks = 1